import { useState } from 'react';
import { useTranslation } from '@shared/core';
import { useThanksForRSVPTelemetry } from '@apps/thanksForRsvp/ThanksForRSVP.telemetry';
import { withWindow } from '@shared/utils/withWindow';
import { useFeatureValue } from '@shared/core/featureFlags';

export const useCongratulationsController = (eventHandle: string) => {
  const { value } = useFeatureValue('rsvpVersion');
  const isVersionA = value === 'basic';
  const [showPreview, setShowPreview] = useState(false);
  const [message, setMessage] = useState('');
  const { t } = useTranslation('thanksForRSVP');
  const tCongratulationsCard = t('congratulationsCard');
  const { backToWebsiteClicked } = useThanksForRSVPTelemetry();
  const handleBackToWebsite = () => {
    backToWebsiteClicked({ isGWScreen: true });
    withWindow(global => {
      global.location.href = `${global.location.origin}/${eventHandle}`;
    });
  };

  return {
    isVersionA,
    showPreview,
    setShowPreview,
    message,
    setMessage,
    tCongratulationsCard,
    handleBackToWebsite,
  };
};
